import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  filterContainer: () => ({
    height: "80px",
    backgroundColor: "#FAFBFC",
    fontSize: theme.typography.pxToRem(16),
    color: "#45547C",
  }),
  formControl: {
    width: "226px",
    marginRight: "15px",
    "& .MuiFormControl-marginNormal": {
      margin: "0px",
    },
    "& .MuiInputBase-formControl": {
      margin: "0px",
      height: "48px",
      backgroundColor: "white",
      "& .MuiSelect-select": {
        fontStyle: "Initer, serif",
        color: "#000000",
        fontWeight: "400",
        fontSize: theme.typography.pxToRem(16),
        backgroundColor: "transparent",
      },
    },
    [theme.breakpoints.down("md")]: {
      width: "120px",
    },
  },
  filtersIcon: {
    padding: 0,
  },
  badge: {
    color: "#235693",
  },
}));
